import { render, staticRenderFns } from "./Jointable.vue?vue&type=template&id=6797cf9c&scoped=true"
import script from "./Jointable.vue?vue&type=script&lang=js"
export * from "./Jointable.vue?vue&type=script&lang=js"
import style0 from "./Jointable.vue?vue&type=style&index=0&id=6797cf9c&prod&scoped=true&lang=css"
import style1 from "./Jointable.vue?vue&type=style&index=1&id=6797cf9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6797cf9c",
  null
  
)

export default component.exports